import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from 'dashboard/helper/inbox';

function inboxChannelType(inbox) {
  return inbox?.channel_type || inbox?.channelType;
}

function normalizeWaMePhone(phone) {
  if (!phone) return null;
  const cleaned = String(phone)
    .replace(/^whatsapp:/i, '')
    .replace(/\D/g, '');
  return cleaned.length ? cleaned : null;
}

/**
 * Customer-facing URL for starting a conversation on this channel, when known.
 * @param {object} inbox inbox payload from the store/API
 * @returns {string|null}
 */
export function getChannelChatLinkUrl(inbox) {
  if (!inbox) return null;

  const type = inboxChannelType(inbox);

  if (type === INBOX_TYPES.FB) {
    const pageId = inbox.page_id || inbox.pageId;
    if (pageId) return `https://m.me/${pageId}`;
  }

  if (type === INBOX_TYPES.TELEGRAM) {
    const botName = inbox.bot_name || inbox.botName;
    if (botName) {
      const handle = String(botName).replace(/^@/, '').trim();
      return handle ? `https://t.me/${handle}` : null;
    }
  }

  if (type === INBOX_TYPES.WHATSAPP || type === INBOX_TYPES.WHATSAPP_BROWSER) {
    const digits = normalizeWaMePhone(inbox.phone_number || inbox.phoneNumber);
    return digits ? `https://wa.me/${digits}` : null;
  }

  if (type === INBOX_TYPES.TWILIO) {
    const medium = inbox.medium || '';
    if (medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP) {
      const digits = normalizeWaMePhone(
        inbox.phone_number || inbox.phoneNumber
      );
      return digits ? `https://wa.me/${digits}` : null;
    }
  }

  if (type === INBOX_TYPES.WEB) {
    const raw = (inbox.website_url || inbox.websiteUrl || '').trim();
    if (!raw) return null;
    if (/^https?:\/\//i.test(raw)) return raw;
    return `https://${raw}`;
  }

  if (type === INBOX_TYPES.EMAIL) {
    const email = inbox.email;
    if (email) return `mailto:${email}`;
  }

  return null;
}
